import React, { Component } from 'react';
import './ShowWindow.css';
import { ReactComponent as CloseMessage } from './images/close-message.svg';
import { ReactComponent as FullScreen } from './images/f-screen.svg';

class ShowWindow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hide: false,
      fullScreen: false,
      style: {},
    };
  }

  onCloseClick = (value) => {
    this.setState({ hide: true });
  };

  onPopoutClick = () => {
    const fullscreen = !this.state.fullScreen;
    this.setState({
      fullScreen: fullscreen,
      style: !fullscreen && this.state.style ? this.props.style : {},
    });
  };

  componentWillUnmount() {
    window.emitter.removeListener('sidebarChanged', this.sidebarEmitter);
    // this.sidebarEmitter.remove();
    document.removeEventListener('keydown', this.escFunction, false);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
    if (!this.state.fullScreen && this.props.style)
      this.setState({ style: this.props.style });
    // LISTEN FOR SIDEPANEL CHANGES
    this.sidebarEmitter = (isSidebarOpen) => this.sidebarChanged(isSidebarOpen);
    window.emitter.addListener('sidebarChanged', this.sidebarEmitter);
  }

  sidebarChanged = (isSidebarOpen) => {
    this.forceUpdate();
  };

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.setState({ hide: true });
    }
  };

  // GET STORAGE
  getStorage() {
    const storage = localStorage.getItem(this.storageKey);
    if (storage === null) return [];

    const data = JSON.parse(storage);
    return data;
  }

  render() {
    let className = '';
    if (this.state.hide) className = 'fs-hidden';
    else if (this.state.fullScreen) className = 'overlay';
    else if (this.props.mode === 'full') className = 'full';
    else if (!window.sidebarOpen) className = 'full';

    let hideScrollClassName = '';
    if (this.props.hideScroll && !this.state.fullScreen)
      hideScrollClassName = 'fs-show-window-content-no-scroll';

    return (
      <div
        id="fs-show-window-container"
        className={className}
        style={this.state.style}
      >
        <div className="fs-show-window-header no-print">
          <div className="fs-show-window-header-title">{this.props.title}</div>
          <div
            className="fs-show-window-header-popout-button"
            title={this.state.fullScreen ? 'Restore Down' : 'Puni zaslon'}
          >
            <button className="information-button" onClick={this.onPopoutClick}>
              <FullScreen style={{ height: '10px', strokeWidth: '5px' }} />
            </button>
          </div>
          <div className="fs-show-window-header-close-button" title="Zatvori">
            <button
              style={{ fontWeight: 'bolder' }}
              className="information-button"
              onClick={this.onCloseClick}
            >
              <CloseMessage style={{ height: '10px' }} />
            </button>
          </div>
        </div>
        <div
          id="fs-show-window-content"
          className={
            this.props.showFooter
              ? 'fs-show-window-content with-footer ' + hideScrollClassName
              : 'fs-show-window-content ' + hideScrollClassName
          }
        >
          {this.props.contents}
        </div>
        <div
          className={
            this.props.showFooter ? 'fs-show-window-footer' : 'fs-hidden'
          }
        >
          <button className="fs-button" onClick={this.onCloseClick}>
            Zatvori
          </button>
        </div>
      </div>
    );
  }
}

export default ShowWindow;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)));
  return images;
}
